import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  input: {
    [theme.breakpoints.down('md')]: {
      '& textarea': {
        fontSize: 14,
        lineHeight: '18px',
      },
    },
    [theme.breakpoints.downLandscape('md')]: {
      ...(theme.isMobileDevice && {
        '& textarea': {
          fontSize: 14,
          lineHeight: '18px',
        },
      }),
    },
  },
  buttons: {
    paddingBottom: 0,
    [theme.breakpoints.down('lg')]: {
      '& #accept-button': {
        width: 110,
      },
    },
    [theme.breakpoints.down('md')]: {
      paddingLeft: 0,
      '& #accept-button': {
        width: 144,
        height: 44,
      },
    },
    [theme.breakpoints.downLandscape('lg')]: {
      ...(theme.isMobileDevice && {
        '& #accept-button': {
          width: 110,
        },
      }),
    },
    [theme.breakpoints.downLandscape('md')]: {
      ...(theme.isMobileDevice && {
        paddingLeft: 0,
        '& #accept-button': {
          width: 144,
          height: 44,
        },
      }),
    },
  },
}));
